import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["src", "onload", "retryInterval", "max", "className", "onclick"];
import "core-js/modules/web.timers.js";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import './index.less';
var LODING_IMG = 'https://res.qiyukf.net/operation/71c928a93165094a3ef1963d6352287a';
var FAIL_IMG = 'https://res.qiyukf.net/operation/041d73eb418d0ef23110dc35d1b87529';
var BTN_IMGx1 = 'https://res.qiyukf.net/operation/8ed2e6050ebdff0d1977e1c9aecdef0a?imageView&thumbnail=28x28';
var BTN_IMG = 'https://res.qiyukf.net/operation/8ed2e6050ebdff0d1977e1c9aecdef0a?imageView&thumbnail=56x56 2x,' + 'https://res.qiyukf.net/operation/8ed2e6050ebdff0d1977e1c9aecdef0a?imageView&thumbnail=84x84 3x';
var defaultProps = {
  retryInterval: 3000,
  max: 20,
  className: '',
  onload: function onload() {},
  onclick: function onclick() {},
  title: '',
  alt: ''
};

var MessageImage = function MessageImage(props) {
  var src = props.src,
      onload = props.onload,
      retryInterval = props.retryInterval,
      max = props.max,
      className = props.className,
      onclick = props.onclick,
      other = _objectWithoutPropertiesLoose(props, _excluded);

  var _useState = useState('loading'),
      status = _useState[0],
      setStatus = _useState[1];

  var instanceRef = useRef({
    count: 0,
    image: null
  });
  var resetStatus = useCallback(function () {
    instanceRef.current = {
      count: 0,
      image: null
    };
  }, []);
  var reload = useCallback(function () {
    setStatus('loading');
    var image = new Image();
    instanceRef.current.image = image;

    image.onerror = function () {
      instanceRef.current.count++;

      if (instanceRef.current.count === max) {
        setStatus('fail');
        resetStatus();
      } else {
        setTimeout(function () {
          image.src = src;
        }, retryInterval);
      }
    };

    image.onload = function () {
      setStatus('success');
      resetStatus();
    };

    image.src = src;
  }, [src, max, retryInterval, resetStatus]);
  var view;

  if (status === 'loading') {
    view = /*#__PURE__*/React.createElement("img", {
      src: LODING_IMG,
      alt: "loading",
      onLoad: onload,
      className: "m-message-image_loading"
    });
  } else if (status === 'fail') {
    view = /*#__PURE__*/React.createElement("div", {
      className: "m-message-image_failwrap"
    }, /*#__PURE__*/React.createElement("img", {
      src: FAIL_IMG,
      alt: "fail",
      onLoad: onload,
      className: "m-message-image_fail"
    }), /*#__PURE__*/React.createElement("img", {
      className: "m-message-image_retrybtn",
      src: BTN_IMGx1,
      srcSet: BTN_IMG,
      onClick: reload
    }));
  } else {
    view = /*#__PURE__*/React.createElement("img", _extends({
      src: src,
      onLoad: onload,
      onClick: onclick
    }, other, {
      className: "m-message-image_pic"
    }));
  }

  useEffect(function () {
    reload();
    return function () {
      instanceRef.current = {
        count: 0,
        image: null
      };
    };
  }, [reload]);
  return /*#__PURE__*/React.createElement("div", {
    className: "m-message-image " + className
  }, view);
};

MessageImage.defaultProps = defaultProps;
export default MessageImage;